import React from 'react';
import {
  LINK_MANAGEMENT,
} from '../../../../../../../constants/links';
import {
  pushLocation,
} from '../../../../../../../router';
import withState from '../../../../../../../utils/withState';
import {
  accountType$,
  bankAccountId$,
} from './state';
import accountTypes from "./constants/accountType";
import AccountTabBtn from "./components/AccountTabBtn";
import {MerchantPageHeader} from "../../../../../../helpers/Display";

function handleBack() {
  const type = accountType$.getValue();
  const link = LINK_MANAGEMENT;
  const path = type
    ? `${link}?type=${type}`
    : link;
  pushLocation({path});
}

module.exports = withState(() => {
  return (state, props) => {
    const {id, type} = state;

    const edit = !!id && id !== 'create';

    const activeTab = state.type || 'bankAccounts';

    const title = activeTab === 'bankAccounts' ? 'Bank Account' : 'Stablecoin Account';

    const ActiveComponent = (accountTypes.find((el) => el.id === activeTab)|| {}).formComponent;

    return (
     <div className={props.className}>
       <MerchantPageHeader
         title={`${edit ? 'Edit ' : 'New '}${title}`}
         backFN={handleBack}
       />
        {/*<div className="layoutRow fhaB fvaC">*/}
        {/*  <ButtonBack*/}
        {/*    className="m-10 mr10"*/}
        {/*    onClick={handleBack}*/}
        {/*  />*/}
        {/*  <Caption>*/}
        {/*    {edit ? 'Edit ' : 'New '}{title}*/}
        {/*  </Caption>*/}
        {/*</div>*/}
       <div className="layoutRow fhaB fvaC mt30">
         <div className="layoutRow fhaB fvaC">
           {accountTypes.map((el) => (
             <AccountTabBtn
               key={el.id}
               id={el.id}
               title={el.title}
               activeTabId={activeTab}
               disabled={edit}
             />
           ))}
         </div>
       </div>
       {ActiveComponent
         ? (
           <ActiveComponent
             className="mt35"
             edit={edit}
             handleBack={handleBack}
           />
         ) : <span />
       }
      </div>
    );
  };
}, {
  id: bankAccountId$,
  type: accountType$,
});
